import classNames from "classnames/bind";
import { ColourOption } from "@/components/Colours/types.ts";

import styles from "./ColourList.module.scss";
import { Swatches } from "@/components/Colours/ColourList/Swatches/Swatches.tsx";
import { Picker } from "@/components/Colours/ColourList/Picker/Picker.tsx";
import { isDiorBrand } from "@JohnLewisPartnership/jl-design-system/dist/utils/brands/brands";

const cx = classNames.bind(styles);

type Props = {
  /**
   * An array of colour option objects.
   */
  colourOptions: ColourOption[];
  /**
   * A string which represents the product brand name.
   */
  brand?: string;
  /**
   * A boolean which indicates if the device is mobile.
   */
  isMobile?: boolean;
  /**
   * A boolean toggling history push with replace
   */
  replaceHistoryEntryOnVariantChange: boolean;
};

export const ColourList = ({
  brand,
  colourOptions,
  isMobile,
  replaceHistoryEntryOnVariantChange,
}: Props) => {
  const selectedColourIndex = colourOptions.findIndex((c) => c.selected);
  const selectedColourOption = colourOptions[selectedColourIndex];

  if (!selectedColourOption || !selectedColourOption) {
    return null;
  }

  const isDior = isDiorBrand(brand);

  return (
    <div className={cx("wrapper")}>
      <h4 data-testid="colourlist:label" className={cx("selectedColour")}>
        <span>Colour: </span>
        <span className={cx("title")}>{selectedColourOption?.colour}</span>
      </h4>
      {colourOptions.length > 8 && (
        <Picker
          selectedColourOption={selectedColourOption}
          colourOptions={colourOptions}
          replaceHistoryEntryOnVariantChange={
            replaceHistoryEntryOnVariantChange
          }
        />
      )}
      <Swatches
        colourOptions={colourOptions}
        isDior={isDior}
        selectedColourIndex={selectedColourIndex}
        isMobile={isMobile}
        replaceHistoryEntryOnVariantChange={replaceHistoryEntryOnVariantChange}
      />
    </div>
  );
};
